import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i2 from 'reference-library';
import * as i3 from '@angular/common';
import * as i4 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';

class FbCustomChipSelectionService {
    constructor() { }
}
FbCustomChipSelectionService.ɵfac = function FbCustomChipSelectionService_Factory(t) { return new (t || FbCustomChipSelectionService)(); };
FbCustomChipSelectionService.ɵprov = i0.ɵɵdefineInjectable({ token: FbCustomChipSelectionService, factory: FbCustomChipSelectionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomChipSelectionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function FbCustomChipSelectionComponent_div_2_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("pTooltip", item_r1 == null ? null : item_r1.info);
} }
const _c0 = function (a0) { return { "selected-chip": a0 }; };
function FbCustomChipSelectionComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵlistener("click", function FbCustomChipSelectionComponent_div_2_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.selectChip(item_r1.code, "refDataArr"); });
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FbCustomChipSelectionComponent_div_2_i_4_Template, 1, 1, "i", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r0.inputArraySelection[item_r1.code]));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r1 == null ? null : item_r1.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1 == null ? null : item_r1.info);
} }
const _c1 = function (a0) { return { "width": a0 }; };
class FbCustomChipSelectionComponent {
    constructor(fb, referenceLibraryService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.observableSubscription$ = new Subject();
        this.refDataArr = [];
        this.inputArraySelection = {};
        this.selectedChipValues = [];
    }
    ngOnInit() {
        var _a;
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value ? this.inputParams.value : null));
        if (this.inputParams && this.inputParams.properties && this.inputParams.properties.isDataFromApi && this.inputParams.properties.refercenceCodeForApiCall != '' && !((_a = this.inputParams.properties) === null || _a === void 0 ? void 0 : _a.dependency)) {
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value.code : null)
            });
            this.referenceLibraryService
                .getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '')
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.refDataArr = response || [];
            });
        }
        else {
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value : null)
            });
            this.refDataArr = [];
        }
        this.preSelectedValues = this.group.get([this.formControlName]).value;
        if (this.preSelectedValues && Array.isArray(this.preSelectedValues)) {
            this.preSelectedValues.forEach((code) => {
                this.inputArraySelection[code] = true;
                this.selectedChipValues.push(code);
            });
        }
    }
    selectChip(code, arrayName) {
        this.inputArraySelection[code] = !this.inputArraySelection[code];
        if (this.inputArraySelection[code]) {
            this.selectedChipValues.push(code);
        }
        else {
            const index = this.selectedChipValues.indexOf(code);
            if (index !== -1) {
                this.selectedChipValues.splice(index, 1);
            }
        }
        this.group.get([this.formControlName]).patchValue(this.selectedChipValues);
    }
}
FbCustomChipSelectionComponent.ɵfac = function FbCustomChipSelectionComponent_Factory(t) { return new (t || FbCustomChipSelectionComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService)); };
FbCustomChipSelectionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbCustomChipSelectionComponent, selectors: [["lib-fb-custom-chip-selection"]], inputs: { inputParams: "inputParams", value: "value", group: "group", formControlName: "formControlName" }, decls: 3, vars: 7, consts: [[3, "formGroup"], [1, "chip-container", 2, "height", "150px", "overflow", "auto", 3, "formControlName"], ["class", "chip-tag-container", 4, "ngFor", "ngForOf"], [1, "chip-tag-container"], [1, "chip-tag", "col-2", 3, "ngClass", "click"], [1, "chip-text"], ["class", "info-icon fa fa-info-circle", 3, "pTooltip", 4, "ngIf"], [1, "info-icon", "fa", "fa-info-circle", 3, "pTooltip"]], template: function FbCustomChipSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, FbCustomChipSelectionComponent_div_2_Template, 5, 5, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c1, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formControlName", ctx.formControlName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.refDataArr);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i1.NgControlStatus, i1.FormControlName, i3.NgForOf, i3.NgClass, i3.NgIf, i4.Tooltip], styles: [".chip-container[_ngcontent-%COMP%]{width:300px;padding:5px}.chip-tag-container[_ngcontent-%COMP%]{cursor:pointer}.chip-tag[_ngcontent-%COMP%]{padding:3px 12px;background:#fff;border:2px solid #98caea;color:#000;font-size:12px;border-radius:10px;margin:8px 8px 0 0;min-width:70px;float:left;font-weight:700;display:flex;width:20%;height:40px;box-sizing:border-box;justify-content:space-between}.chip-text[_ngcontent-%COMP%]{width:90%;display:flex;align-items:center;justify-content:center}.chip-cross-icon[_ngcontent-%COMP%]{font-size:12px;width:10%;cursor:pointer}.selected-chip[_ngcontent-%COMP%]{background-color:#d1edff}.info-icon[_ngcontent-%COMP%]{display:flex;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomChipSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-custom-chip-selection',
                templateUrl: 'fb-custom-chip-selection.component.html',
                styleUrls: ['fb-custom-chip-selection.component.scss']
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.ReferenceLibraryService }]; }, { inputParams: [{
            type: Input
        }], value: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class FbCustomChipSelectionModule {
}
FbCustomChipSelectionModule.ɵfac = function FbCustomChipSelectionModule_Factory(t) { return new (t || FbCustomChipSelectionModule)(); };
FbCustomChipSelectionModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbCustomChipSelectionModule });
FbCustomChipSelectionModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbCustomChipSelectionModule, { declarations: [FbCustomChipSelectionComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [FbCustomChipSelectionComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbCustomChipSelectionModule, [{
        type: NgModule,
        args: [{
                declarations: [FbCustomChipSelectionComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                ],
                exports: [FbCustomChipSelectionComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-custom-chip-selection
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbCustomChipSelectionComponent, FbCustomChipSelectionModule, FbCustomChipSelectionService };
//# sourceMappingURL=fb-custom-chip-selection.js.map
